import i18next from './i18n';

export function changeLanguage(language) {
    i18next.changeLanguage(language);
}

export function getDataByLanguage(language = i18next.language) {
    return (
        i18next.getDataByLanguage(language)?.translation ??
        i18next.getDataByLanguage(i18next.options.fallbackLng)?.translation
    );
}

export function interpolateString(key, args) {
    return i18next.t(key, args);
}

export function loadCustomLabelTranslations(translations) {
    const languages = ['en', 'es', 'fr', 'pt'];

    languages.forEach((language) =>
        i18next.addResourceBundle(
            language,
            'translation',
            {
                customLabels: translations[language] ?? {},
            },
            true
        )
    );
}

export function addCustomLabelsResourceBundle(
    customLabels,
    language = i18next.language
) {
    i18next.addResourceBundle(
        language,
        'translation',
        {
            customLabels: customLabels ?? {},
        },
        true
    );
}
